import { InjectionToken } from '@angular/core';

export interface IAnalyticsService {
    trackEventSimple(eventType: string, classId?: string, jsonData?: object): void;
    trackEvent(event: any): void;
    trackGSPerfEvent(eventType: string, classId: string, gameShowRunId?: string): void;
}

export const ANALYTICS_SERVICE_TOKEN = new InjectionToken<IAnalyticsService>('IAnalyticsService');